import LocalStorageConstant from '../../constants/localstroage.constant.ts';
import { v4 as uuidv4 } from "uuid";

const getCorrelationId = (): string => {
  const existing = localStorage.getItem(LocalStorageConstant.correlationId);

  if (existing) return existing;

  const generated = uuidv4();
  localStorage.setItem(LocalStorageConstant.correlationId, generated);

  return generated;
};

const addOrUpdateLocalCorrelationId = (correlationId: string) => {
  localStorage.setItem(LocalStorageConstant.correlationId, correlationId);
};

const getUser: any = () => {
  const user: string | null = localStorage.getItem(LocalStorageConstant.userName);
  return user;;
};

const setUser = (user: any) => {
  localStorage.setItem(LocalStorageConstant.userName, JSON.stringify(user) ?? '');
};

const removeUser = () => {
  localStorage.removeItem(LocalStorageConstant.userAddresses);
  localStorage.removeItem(LocalStorageConstant.userName);
  localStorage.removeItem(LocalStorageConstant.access_token);
  localStorage.removeItem(LocalStorageConstant.refresh_token);
  localStorage.removeItem(LocalStorageConstant.expires_in);
  localStorage.removeItem(LocalStorageConstant.correlationId);
};

const TokenService = {
  addOrUpdateLocalCorrelationId,
  getCorrelationId,
  getUser,
  setUser,
  removeUser,
};

export default TokenService;
